import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.hard-token-management.edit.synchronize', {
        url: '/synch',
        component: 'editHardTokenSynchronize',
       
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-edit/synchronize/hard-token-synchronize.state.js